import React from 'react';
import styled from 'styled-components';
import { FormikValues, useFormikContext } from 'formik';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from 'src/components/Common/formik/input/TextField';

/* interface IStyledProps {
  isActive?: boolean;
  loading?: boolean;
  selected?: boolean;
} */
const ListingSection = styled.div`
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: flex-start;
  width: 100%;
`;
const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  & > div {
    width: 100%;
  }
`;
const TitleWrapper = styled.div`
  margin: 24px 0 12px;
`;
const Title = styled.h1`
  font-size: 25px;
  line-height: 40px;
  font-weight: 700;
  margin: 0;
  color: ${({ theme }) => theme.colors.secondary};
`;
const StyledInput = styled(Input)`
  //width: 33.3%;
`;
const StyledSelect = styled(FormControl)`
  //width: 33.3%;
`;

type TProperty = {
  datatype: string;
  is_mandatory: boolean;
  name: string;
  possible_options: string | null;
  slug: string;
};
type TProps = {
  properties: TProperty[];
};
const OtherDetails = ({ properties }: TProps) => {
  const { values, errors, touched, setFieldValue, setFieldTouched } = useFormikContext<
    FormikValues
  >();
  return (
    <ListingSection>
      <TitleWrapper>
        <Title>Other details</Title>
      </TitleWrapper>
      <Container>
        {properties.map((property) => {
          const OptionsList =
            (property.possible_options &&
              JSON.parse(property.possible_options).map((item: string) => ({
                label: item,
                id: item,
              }))) ||
            [];
          return (
            (property.possible_options == null && (
              <StyledInput
                name={property.name}
                label={property.name}
                value={values[property.name]}
                placeholder={`Enter ${property.name}`}
                onBlurHandler={() => setFieldTouched(property.name, true)}
                onChangeHandler={(val) => setFieldValue(property.name, val)}
                margin="normal"
                outlined
                error={touched[property.name] && errors[property.name]}
                errorText={touched[property.name] && errors[property.name]}
              />
            )) || (
              <StyledSelect
                error={values[property.name] === 'Select option'}
                margin="normal"
                variant="outlined"
              >
                <InputLabel id={`${property.name}-label`} shrink>
                  {`Select ${property.name}`}
                </InputLabel>
                <Select
                  labelId={`${property.name}-label`}
                  id={property.name}
                  value={values[property.name] || 'Select option'}
                  onChange={(event) => {
                    setFieldValue(property.name, event.target.value);
                  }}
                  renderValue={(value) => (value !== undefined && `${value}`) || 'Select option'}
                  label={`Select ${property.name}`}
                >
                  <MenuItem value="Select option">{`Select ${property.name}`}</MenuItem>
                  {OptionsList.map((item: { label: string; id: string }, indx: number) => {
                    return (
                      <MenuItem key={indx} value={item.id}>
                        {item.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </StyledSelect>
            )
          );
        })}
      </Container>
    </ListingSection>
  );
};

export default OtherDetails;
